import { pull } from 'lodash';
import constants from '../Constants';
const {
  GET_JOBS,
  JOB_LOADING,
  DELETE_JOB,
  ADD_JOB,
  ADD_JOB_FAIL,
  UPDATE_JOB,
  UPDATE_JOB_FAIL,
  RESET_JOBS_ALERT,
  JOB_SUBMITTED,
  LOGOUT
} = constants;

const INIT_STATE = {
  jobs:{},
  jobsMeta:{lastPage: false,total: false, currentPage: 1, perPage: 20},
  jobsLoading: true,
  jobSubmitted: false,
  alert: { add: false, edit: false, delete: false, get: false },
  query: {},
  data: [],
};

const JobReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_JOBS:
      const { data, query } = action.payload;
      const { entities, result } = data; 
      return { 
            ...state, 
            jobs: entities.jobs, // --->To be fixed and appended
            jobsMeta: {
                total: result.total,
                lastPage: result.last_page,
                currentPage: result.current_page,
                perPage: result.per_page,
                data: result.data,
            },
            jobsLoading: false,
            query: query,
        };

    case JOB_LOADING:
        return {
            ...state,jobsLoading: true,
        };
    case DELETE_JOB:
        const { jobsMeta, jobsMeta: { total, data: metaData } } = state;
        const { [action.payload.toString()]: removed, ...rest } = state.jobs;
        const newMeta = { ...jobsMeta, total: total-1, data: pull(metaData, action.payload) };
        
        return { ...state, jobs: rest, jobsMeta: newMeta, alert: INIT_STATE.alert };
    
    case ADD_JOB:

        return {
            ...INIT_STATE,
            alert: { ...INIT_STATE.alert, add: { type: "success", message: "Job added successfully." }},
        };
    
    case ADD_JOB_FAIL:
        return {
            ...state,
            jobSubmitted: false,
            alert: { ...INIT_STATE.alert, add: { type: "warning", message: action.payload }},
        };

    case UPDATE_JOB:{
        const { vanity_id, status } = action.payload;
        const jobs = {...state.jobs,[vanity_id]: action.payload };
        const { query: { status: filterStatus = [] }, jobsMeta, jobsMeta: { data = [], total } } = state;
        const newData = filterStatus.length > 0 && filterStatus.includes(status) ?
        data: pull(data, vanity_id);
        return {
            ...state, 
            jobsMeta: { 
                ...jobsMeta, 
                data: newData, 
                ...(filterStatus.length > 0 && !filterStatus.includes(status) && { total: total -1 }),
            },
            jobs, 
            jobSubmitted: false, 
            alert: { 
                ...INIT_STATE.alert, 
                edit: { type: "success", message: "Job updated successfully." }
            }
        };
    }
    case UPDATE_JOB_FAIL:
        return {
            ...state,
            jobSubmitted: false,
            alert: { ...INIT_STATE.alert, edit: { type: "warning", message: action.payload }},
        };
    case RESET_JOBS_ALERT:
        return {
            ...state,
            alert: INIT_STATE.alert,
        };
    
    case JOB_SUBMITTED:
        return {
            ...state,
            jobSubmitted: true,
        };
        
    case LOGOUT:
        return INIT_STATE;

    default:
        return state;
  }
}

export default JobReducer;


// WEBPACK FOOTER //
// ./src/Reducers/JobReducer.js